export default __webpack_public_path__ + "static/media/unico.b4993f58.jpg";